import { motion } from 'framer-motion';
import { BOOK_AUTHOR } from '../../lib/constants';

export function AuthorBio() {
  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="flex flex-col md:flex-row items-center gap-10"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex-shrink-0 w-48 h-48 rounded-full overflow-hidden bg-gradient-to-br from-sage to-sage-dark">
            <img
              src="/AbrahamCuenca.jpg"
              alt={BOOK_AUTHOR}
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            <h2 className="font-serif text-3xl font-bold text-text mb-2">
              About the author
            </h2>
            <p className="text-sage-dark font-medium mb-4">Abraham &ldquo;Abe&rdquo; Cuenca</p>
            <p className="text-text-light leading-relaxed mb-4">
              Abe is a father and writer who wrote this book after a conversation with
              his daughter and her fiancé about the debt so many people their age are
              carrying. It's the book he wishes someone had handed him in his twenties:
              a calm, clear walk-through of the money rules nobody bothered to explain.
            </p>
            <p className="text-text-light leading-relaxed italic">
              &ldquo;You're not bad with money. You're under-taught and overburdened,
              doing your best with incomplete information. This book isn't here to make
              you feel worse. It's here to give you a calmer place to begin.&rdquo;
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
